import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Text } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function NavItem(props) {
  var title = props.title,
    rest = _objectWithoutProperties(props, _excluded);
  return _jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, rest), titleStyles), {}, {
    textAlign: "center",
    children: title
  }));
}
var titleStyles = {
  w: {
    lg: '11.5rem',
    xl: '12.375rem'
  },
  cursor: 'pointer',
  fontSize: 'lg',
  lineHeight: '3',
  color: 'darkGrey1',
  whiteSpace: 'nowrap',
  _focusVisible: {
    outline: 'none'
  },
  _hover: {
    color: 'primary'
  },
  mb: 0
};